"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldGroup = exports.FormDivider = exports.FormLines = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const PresentationContext_1 = require("../components/PresentationContext");
const Css_1 = require("../Css");
/**
 * Applies standard Form layout/size/spacing between lines.
 *
 * Lines can either be individual form fields, or a group of form fields
 * (see the `FieldGroup` component), where they will be laid out side-by-side.
 */
function FormLines(props) {
    const { children, width = "full", labelSuffix, labelStyle, compact } = props;
    let firstFormHeading = true;
    // Only overwrite `fieldProps` if new values are explicitly set. Ensures we only set to `undefined` if explicitly set.
    const newFieldProps = {
        ...("labelSuffix" in props ? { labelSuffix } : {}),
        ...("labelStyle" in props ? { labelStyle } : {}),
        ...("compact" in props ? { compact } : {}),
    };
    return ((0, jsx_runtime_1.jsx)(PresentationContext_1.PresentationProvider, { fieldProps: newFieldProps, children: (0, jsx_runtime_1.jsx)("div", { css: {
                // Note that we're purposefully not using display:flex so that our children's margins will collapse.
                ...Css_1.Css.w(sizes[width]).$,
                // Purposefully use this instead of childGap3 to put margin-bottom on the last line
                "& > *": Css_1.Css.mb2.$,
            }, children: react_1.Children.map(children, (child) => {
                if (child && typeof child === "object" && "type" in child && child.type.isFormHeading) {
                    const clone = (0, react_1.cloneElement)(child, { isFirst: firstFormHeading });
                    firstFormHeading = false;
                    return clone;
                }
                else {
                    return child;
                }
            }) }) }));
}
exports.FormLines = FormLines;
/** Draws a line between form lines. */
function FormDivider() {
    return (0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.hPx(1).my2.bgGray200.$ });
}
exports.FormDivider = FormDivider;
/** Groups multiple fields side-by-side. */
function FieldGroup(props) {
    // TODO Actually use title
    const { title, children, widths = [] } = props;
    const gtc = children
        .map((_, i) => {
        const width = widths[i] || 1;
        return typeof width === `number` ? `${width}fr` : width;
    })
        .join(" ");
    return (0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.dg.gap2.gtc(gtc).$, children: children });
}
exports.FieldGroup = FieldGroup;
const sizes = {
    full: "100%",
    lg: "550px",
    md: "480px",
    sm: "320px",
};
